module.exports = __webpack_public_path__ + "static/media/line.8ec34383.png";